import GameThumbnail from '@/src/components/Thumbnail/GameThumbnail'
import GameThumbnailLabels from '@/src/components/Thumbnail/GameThumbnailLabels'
export { GameThumbnail, GameThumbnailLabels }
